// extracted by mini-css-extract-plugin
export default {"workoutSection":"Workout_workoutSection__RoaYi","iconHolder":"Workout_iconHolder__EUCfd","btnBox":"Workout_btnBox__K5RxZ"};